import React from 'react';
import type { BombiixIconProps } from './types';

/** Bombiix Position Left icon — blocks aligned to a left edge (Bombiix 2026, "Component Alignmnet Left to right", first cell). */
const PositionLeftIcon: React.FC<BombiixIconProps> = ({ size = 20, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...rest}>
    <path
      d="M3.3335 4.66699V15.3337M7.3335 8.66699H15.3335C16.0699 8.66699 16.6668 8.07004 16.6668 7.33366V6.00033C16.6668 5.26395 16.0699 4.66699 15.3335 4.66699H7.3335C6.59712 4.66699 6.00016 5.26395 6.00016 6.00033V7.33366C6.00016 8.07004 6.59712 8.66699 7.3335 8.66699ZM7.3335 15.3337H11.3335C12.0699 15.3337 12.6668 14.7367 12.6668 14.0003V12.667C12.6668 11.9306 12.0699 11.3337 11.3335 11.3337H7.3335C6.59712 11.3337 6.00016 11.9306 6.00016 12.667V14.0003C6.00016 14.7367 6.59712 15.3337 7.3335 15.3337Z"
      stroke="currentColor"
      strokeLinecap="round"
    />
  </svg>
);

export default PositionLeftIcon;
